export default __webpack_public_path__ + "static/media/presentation-1.08c53667.png";